"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _importWarehouse = require("@/api/import-warehouse");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _FilterOrder = _interopRequireDefault(require("./components/FilterOrder.vue"));
var _ImportWarehouseModal = _interopRequireDefault(require("./components/ImportWarehouseModal.vue"));
var _importExcel = require("./components/import-excel");
var ImportWarehouse = /*#__PURE__*/function (_Vue) {
  function ImportWarehouse() {
    var _this;
    (0, _classCallCheck2.default)(this, ImportWarehouse);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ImportWarehouse, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    return _this;
  }
  (0, _inherits2.default)(ImportWarehouse, _Vue);
  return (0, _createClass2.default)(ImportWarehouse, [{
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "handleFilter",
    value: function handleFilter(filters) {
      this.query.page = 1;
      this.filters = filters;
      this.fetchData();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.modal.handleUpdate(row);
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.loading = true;
      _importWarehouse.importWarehouseApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters)).then(function (res) {
        _this2.data = res.data.importWarehouses;
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.modal.handleCreate();
    }
  }, {
    key: "handleExport",
    value: function () {
      var _handleExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var type,
          _args = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              type = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
              this.fetchDataExport(type);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }()
  }, {
    key: "fetchDataExport",
    value: function () {
      var _fetchDataExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(type) {
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loadingExcel = true;
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters);
              delete query.page;
              delete query.limit;
              _context2.prev = 4;
              _context2.next = 7;
              return _importWarehouse.importWarehouseApi.findAll(query);
            case 7:
              res = _context2.sent;
              (0, _importExcel.importWarehouseExcel)({
                data: res.data.importWarehouses,
                type: type
              });
            case 9:
              _context2.prev = 9;
              this.loadingExcel = false;
              return _context2.finish(9);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4,, 9, 12]]);
      }));
      function fetchDataExport(_x) {
        return _fetchDataExport.apply(this, arguments);
      }
      return fetchDataExport;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
ImportWarehouse = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    WarehouseModal: _ImportWarehouseModal.default,
    FilterOrder: _FilterOrder.default
  }
})], ImportWarehouse);
var _default = exports.default = ImportWarehouse;